import OrderStateDelete from './OrderStateDelete'
export {OrderStateDelete}
export default OrderStateDelete
